import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";

export const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "list.xlsx"
        );
      });
    });
  };

  export const getLocalStorageItem = (key) => {
    return localStorage.getItem(key);
  };

  export const getNextScreen = (key) => {
    console.log("sdfdsf", key)
    switch(key){
      case 'employee' : localStorage.setItem("next", 'employeedashboard');
              break;
      case 'employer' : localStorage.setItem("next", 'dashboard');
              break;
      case 'admin' : localStorage.setItem("next", 'copsdashboard');
              break;
      case 'superuser' : localStorage.setItem("next", 'employerdashboard');
              break;
       default : localStorage.setItem("next", 'employeedashboard')
    }
  };


  export const downloadFile = (fileUrl) => {
    const downloadLink = document.getElementById('downloadLink');
    downloadLink.href = fileUrl;
    downloadLink.download = 'Document';
    downloadLink.click();
  }


  // ONWHEEL cHANGE TYPE 1

  export const numberWheelChange = (e) =>  {
    e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })
  }


 